import { CommonModule, CurrencyPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FilterBarplotRangeComponent } from './components/charts/filter-barplot-range/filter-barplot-range.component';
import { PixelTrackingComponent } from './components/tracking/pixel-tracking/pixel-tracking.component';
import { TrackConversionFunnelComponent } from './components/tracking/track-conversion-funnel/track-conversion-funnel.component';
import { CheckboxComponent } from './components/ui/checkbox/checkbox.component';
import { DialogComponent } from './components/ui/dialog/dialog.component';
import { FilterRadioButtonComponent } from './components/ui/filter-radio-button/filter-radio-button.component';
import { MultipleChoiceRadioButtonComponent } from './components/ui/multiple-choice-radio-button/multiple-choice-radio-button.component';
import { HeaderComponent } from './components/ui/header/header.component';
import { HintComponent } from './components/ui/hint/hint.component';
import { InputCurrencyComponent } from './components/ui/input-currency/input-currency.component';
import { CashbackComponent } from './components/ui/offer-card/cashback/cashback.component';
import { BankPromotionComponent } from './components/ui/offer-card/bank-promotion/bank-promotion.component';
import { ConditionsComponent } from './components/ui/offer-card/conditions/conditions.component';
import { CouponTipComponent } from './components/ui/offer-card/coupon/coupon-tip/coupon-tip.component';
import { OfferCardComponent } from './components/ui/offer-card/offer-card.component';
import { ProductComponent } from './components/ui/offer-card/product/product.component';
import { ProofComponent } from './components/ui/offer-card/proof/proof.component';
import { SelectComponent } from './components/ui/select/select.component';
import { SliderComponent } from './components/ui/slider/slider.component';
import { SpinnerComponent } from './components/ui/spinner/spinner.component';
import { DebounceClickDirective } from './directive/debounce-click.directive';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { NumberIntegerPipe } from './pipes/number-integer.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { HeaderTrustElementsComponent } from './components/ui/header/header-trust-elements/header-trust-elements.component';
import { PopupComponent } from './components/ui/popup/popup.component';
import { CouponComponent } from './components/ui/offer-card/coupon/coupon.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { Rsv } from './pipes/rsv.pipe';
import { MobileOfferDetailsComponent } from './components/ui/offer-card/mobile-offer-details/mobile-offer-details.component';
import { PeriodPipe } from './pipes/period.pipe';
import { OfferProgressComponent } from './components/ui/offer-progress/offer-progress.component';
import { CustomerRatingsComponent } from './components/ui/offer-card/customer-ratings/customer-ratings.component';
import { StarRatingComponent } from './components/ui/star-rating/star-rating.component';
import { CustomerFeedbackComponent } from './components/ui/offer-card/customer-feedback/customer-feedback.component';

@NgModule({
  declarations: [
    FilterBarplotRangeComponent,
    CheckboxComponent,
    FilterRadioButtonComponent,
    MultipleChoiceRadioButtonComponent,
    HintComponent,
    InputCurrencyComponent,
    SelectComponent,
    NumberIntegerPipe,
    DebounceClickDirective,
    DateFormatPipe,
    SliderComponent,
    OfferCardComponent,
    ProofComponent,
    MobileOfferDetailsComponent,
    ProductComponent,
    ConditionsComponent,
    HeaderComponent,
    SafePipe,
    PixelTrackingComponent,
    TrackConversionFunnelComponent,
    CashbackComponent,
    CouponTipComponent,
    HeaderTrustElementsComponent,
    PopupComponent,
    CouponComponent,
    OfferProgressComponent,
    BankPromotionComponent,
    SpinnerComponent,
    CustomerRatingsComponent,
    StarRatingComponent,
    CustomerFeedbackComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgIf,
    SvgIconComponent,
    DialogComponent,
    Rsv,
    PeriodPipe,
    NgIf,
  ],
  exports: [
    HintComponent,
    FilterRadioButtonComponent,
    MultipleChoiceRadioButtonComponent,
    CheckboxComponent,
    FilterBarplotRangeComponent,
    InputCurrencyComponent,
    SelectComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NumberIntegerPipe,
    DebounceClickDirective,
    DateFormatPipe,
    SliderComponent,
    OfferCardComponent,
    HeaderComponent,
    PixelTrackingComponent,
    TrackConversionFunnelComponent,
    HeaderTrustElementsComponent,
    DialogComponent,
    ProductComponent,
    ConditionsComponent,
    ProofComponent,
    MobileOfferDetailsComponent,
    OfferProgressComponent,
    BankPromotionComponent,
    SpinnerComponent,
    CustomerRatingsComponent,
    StarRatingComponent,
    CustomerFeedbackComponent,
    PeriodPipe,
  ],
  providers: [CurrencyPipe],
})
export class ShareModule {}
